import { render, staticRenderFns } from "./DialogNewPlayer.vue?vue&type=template&id=4f7573cc&scoped=true&"
import script from "./DialogNewPlayer.vue?vue&type=script&lang=js&"
export * from "./DialogNewPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DialogNewPlayer.vue?vue&type=style&index=0&id=4f7573cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7573cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VLayout,
})
